import { Box, Stack, styled } from '@mui/material';

import { Typography } from '../../atoms/Typography';

/**
 * The dialog surface. Dressed as a panel — the same white card, hairline border
 * and radius as the pages behind it — rather than the hardcoded 1px black
 * border it used to carry, which read as a browser alert.
 */
export const Container = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  border: `1px solid ${theme.palette.v4.border}`,
  backgroundColor: theme.palette.background.paper,
  borderRadius: 8,
  boxShadow: theme.shadows[8],
  padding: '4px 20px 12px',
  // Never exceed the viewport: scroll instead of clipping the top/bottom on short screens.
  maxHeight: 'calc(100vh - 32px)',
  overflowY: 'auto',
}));

export const Footer = styled(Stack)`
  margin-top: 14px;
`;

export const TitleLabel = styled(Typography)`
  margin-top: 4px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 700;
`;

export const ContentBox = styled('div')`
  margin-top: 14px;
  margin-bottom: 4px;
`;
